import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import { partnerFollowRecordList, partnerFollowRecordDelete } from '@/api/marketing/marketingManage'
import { useRoute } from 'vue-router'
import type { PartnerManage } from '@/typings/api/marketingManage'
import partnerFollowRecordFrom from './partnerFollowRecordFrom.vue'

const __default__ = { name: 'PartnerActivity' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  edit: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const route = useRoute()
const table = ref()
const loading = ref(false)
const partnerFollowRecordFromRef = ref()

const disabled = ref(false)
const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.id) {
    partnerFollowRecordList({
      partnerId: route.query.id,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}
// 新增
const handleAdd = () => {
  disabled.value = false
  partnerFollowRecordFromRef.value.toggle({
    partnerName: route.query.name,
    partnerId: route.query.id
  })
}
// 查看
const handleDetail = (row: PartnerManage['partnerContact']) => {
  disabled.value = true
  partnerFollowRecordFromRef.value.toggle({
    ...row,
    partnerName: route.query.name,
    partnerId: route.query.id
  })
}
// 编辑
const handleEdit = (row: PartnerManage['partnerContact']) => {
  disabled.value = false
  partnerFollowRecordFromRef.value.toggle({
    ...row,
    partnerName: route.query.name,
    partnerId: route.query.id
  })
}
// 删除
const handleDelete = (row: PartnerManage['partnerContact']) => {
  Modal.delete({
    onOk() {
      partnerFollowRecordDelete({ id: row.id }).then((res) => {
        table.value.delFetch()
        message.success('删除成功')
      })
    }
  })
}
const success = (type?: 'add' | 'edit') => {
  if (type === 'add') {
    table.value.search()
  } else {
    table.value.fetch()
  }
}
const columns = ref([
  {
    title: '对接人',
    dataIndex: 'partnerContactName'
  },
  {
    title: '维护时间',
    dataIndex: 'followTime'
  },
  {
    title: '具体内容',
    dataIndex: 'content'
  },
  {
    title: '创建人',
    dataIndex: 'createByName'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 200
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cos_table, {
      columns: columns.value,
      tableId: "fbuPartnerFollowRecord",
      onFetch: fetch,
      ref_key: "table",
      ref: table
    }, {
      bodyCell: _withCtx(({ column, record, text }) => [
        (column.dataIndex === 'content')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "link",
              title: text,
              onClick: ($event: any) => (handleDetail(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(text), 1)
              ]),
              _: 2
            }, 1032, ["title", "onClick"]))
          : _createCommentVNode("", true),
        (column.dataIndex === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleEdit(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 编辑 ")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, 'fbu_partner_maintain_edit_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleDelete(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 删除 ")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, 'fbu_partner_maintain_del_btn']
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns"]),
    _createVNode(partnerFollowRecordFrom, {
      ref_key: "partnerFollowRecordFromRef",
      ref: partnerFollowRecordFromRef,
      onSuccess: success,
      disabled: disabled.value
    }, null, 8, ["disabled"]),
    _createVNode(_component_cos_footer_button, {
      loading: loading.value,
      returnName: "DcCosZbuPartnerManage"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAdd())),
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("新增维护记录")
          ]),
          _: 1
        }, 8, ["loading"])), [
          [_directive_permission, 'fbu_partner_maintain_add_btn']
        ])
      ]),
      _: 1
    }, 8, ["loading"])
  ], 64))
}
}

})